"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var theme_1 = require("../theme"); // tslint:disable-line
var Label_1 = tslib_1.__importDefault(require("../Label")); // tslint:disable-line
exports.transitionStyles = {
    transition: 'margin ease-out .25s, font-color ease-out .5s, font-size cubic-bezier(.83,.17,.83,.67) 1s',
};
exports.StyledLabel = theme_1.styled(Label_1.default)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, width = _a.width, status = _a.status;
    var styles = theme.components.floatingPlaceholder[status];
    return tslib_1.__assign({ display: 'inline-block', position: 'relative' }, theme.components.floatingPlaceholder, (_b = {}, _b['input:hover'] = (_c = {},
        _c['& ~ .placeholder'] = {
            color: styles.hoverColor
        },
        _c), _b['input:focus'] = (_d = {},
        _d['& ~ .placeholder'] = {
            color: styles.focusColor
        },
        _d), _b['& .placeholder'] = {
        color: styles.color
    }, _b.width = width, _b));
});
exports.BorderCover = theme_1.styled("span")(function () { return ({
    left: 0,
    height: '1.5px',
    position: 'absolute',
    top: 0,
    transition: 'width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    width: 0.01,
}); });
exports.FloatPlaceholder = theme_1.styled("span")(function () { return ({
    transformOrigin: 'top left',
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
}); });
